import * as React from 'react';
// import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { WhiteBlock } from '../styles/WhiteBlock';

const ConnectIntergration = () => (
  <Layout>
    <SEO title="Home" />
    <div className="db-area-main">
      <div className="db-container">
        <a href="#!" className="db-back-link button-chevron-left">
          <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
          Intergrations
        </a>

        <WhiteBlock>
          <div className="connect-integration-header">
            <div className="flex-row align-items-center">
              <div className="col col-8 ">
                <div className="flex-row nowrap no-margin align-items-center">
                  <img src="/img/instagram.png" alt="" />
                  <div className="flex-1">
                    <h2>Instagram</h2>
                    Connect facebook to publish ads, add signup forms,and access
                    your instagram posts, IGTV, Reels and giude image stories,
                    you can use it in multiple accounts 🌈🙌🏻
                  </div>
                </div>
              </div>
              <div className="col col-4 text-right">
                <button className="button" type="button">
                  Connect
                </button>
              </div>
            </div>
          </div>

          <div className="white-block-body">
            <div className="flex-row">
              <div className="col col-5">
                <h2 className="db-heading" style={{ margin: '20px  0 20px' }}>
                  Before You Start
                </h2>

                <ul className="chain-list">
                  <li>
                    You will need to active instagram account that manages at
                    least one facebook page in order to connect this integration
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one Instagram page
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one facebook page in order to connect this integration
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one Instagram page
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one facebook page in order to connect this integration
                  </li>
                </ul>
              </div>
              <div className="col col-6 offset-1">
                <h2 className="db-heading" style={{ margin: '20px  0 20px' }}>
                  Features
                </h2>
                <ul className="arrow-list">
                  <li>
                    You will need to active instagram account that manages at
                    least one facebook page in order to connect this integration
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one Instagram page
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one facebook page in order to connect this integration
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one Instagram page
                  </li>
                  <li>
                    You will need to active instagram account that manages at
                    least one facebook page in order to connect this integration
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </WhiteBlock>
      </div>
    </div>
  </Layout>
);

export default ConnectIntergration;
